module.exports = __webpack_public_path__ + "img/0Q3C6212_BlackMatted.451bf480.jpg";